const NL = '%0D%0A';
const myIsid = `My ISID: `;
export const buildRequestAccessLink = (supportEmail: string | undefined, userId?: string) => {
  return (
    `mailto:${supportEmail || 'AMS_HEMWB_SUPPORT@merck.com'}?subject=Access Request` +
    `&body=Please provide me with permissions to use Model Repository.${(userId && NL + myIsid + userId) || ''}`
  );
};

export const getAPIBaseURL = () => {
  const environment = process.env.NODE_ENV;
  if (window.location.host === 'localhost') {
    // This condition used to run yarn test without errors while doing mvn build
    return window.location.protocol + '//' + window.location.host;
  } else {
    if (environment === 'development') {
      return 'http://localhost:11000';
    } else {
      const cDomain = window.location;
      let beURL: any = cDomain.origin;
      beURL = cDomain.origin.split('-');
      if (beURL.length === 3) {
        beURL = `${beURL[0]}-${beURL[1].substring(0, 3)}-be${beURL[1].substring(3)}-${beURL[2]}`;
        return beURL;
      }
      if (beURL.length === 2) {
        beURL = `${beURL[0]}-${beURL[1].substring(0, 3)}-be${beURL[1].substring(3)}`;
        return beURL;
      } else if (beURL.length === 1) {
        return 'https://be.hemrepository.com';
      }
      // Use proxy API URL instead of PCF router URL
      //return 'https://api-staging.merck.com/hemrepository/v1/';
    }
  }
  return '';
};

export const getClientURLByEnv = () => {
  return localStorage.getItem('clientURL');
};
